(function($) {
  //caches a jQuery object containing the header element
  var header = $(".header--v5");

  // Header follow
  $(window).scroll(function() {
    var scroll = $(window).scrollTop();

    if (scroll >= 500) {
      header.addClass("active-scroll");
    } else {
      header.removeClass("active-scroll");
    }
  });

  function getActiveMenuItem() {
    const currentLocation = location.href; //.replace(/\/$/, "");

    const activeSubMenu = $(".menu-tendina__sub").find(
      `a[href="${currentLocation}"]`
    );

    const menuActiveClass = "btn-nav--active";
    const subMenuActiveClass = "menu-tendina__sub--active";
    const subMenuChildActiveClass = "sub-menu--active";

    if (activeSubMenu.length > 0) {
      const subMenuChild = activeSubMenu.parents(".sub-menu");
      const subMenu = activeSubMenu.parents(".menu-tendina__sub");
      const menuName = subMenu.data("menu");
      const menu = $(".menu-tendina__nav").find(`li[data-menu="${menuName}"]`);

      menu.addClass(menuActiveClass);
      subMenu.addClass(subMenuActiveClass);

      if (subMenuChild.length > 0) {
        subMenuChild.addClass(subMenuChildActiveClass);
      }

      return;
    }

    // if we dont have an active item in menu
    if (currentLocation.includes("shop")) {
      const menu = $(".menu-tendina__nav").find(`li[data-menu="shop"]`);
      const subMenu = $(`.menu-tendina__sub--shop`);

      menu.addClass(menuActiveClass);
      subMenu.addClass(subMenuActiveClass);
    } else {
      const menu = $(".menu-tendina__nav").find(`li[data-menu="naviga"]`);
      const subMenu = $(`.menu-tendina__sub--naviga`);

      menu.addClass(menuActiveClass);
      subMenu.addClass(subMenuActiveClass);
    }
  }

  function menuDesktop() {
    $(".hamburger").click(function() {
      if (window.innerWidth <= 768) return;

      $(".menu-tendina").toggleClass("menu-tendina--active");
      $(".backplate").toggleClass("backplate--open");
      $(this).toggleClass("is-active");

      getActiveMenuItem();

      if (!$(this).hasClass("is-active")) {
        $(".menu-tendina__sub").removeClass("menu-tendina__sub--active");
        $(".btn-nav").removeClass("btn-nav--active");
        $(".sub-menu").removeClass("sub-menu--active");
      }
    });

    $(".btn-nav").mouseenter(function(e) {
      clearTimeout(window.timeout);

      window.timeout = setTimeout(() => {
        const target = e.currentTarget;
        const menu = $(target).data("menu");

        $(".btn-nav").removeClass("btn-nav--active");
        $(this).addClass("btn-nav--active");
        $(".menu-tendina__sub").removeClass("menu-tendina__sub--active");
        $(`.menu-tendina__sub--${menu}`).addClass("menu-tendina__sub--active");
        $(".sub-menu").removeClass("sub-menu--active");
      }, 200);
    });

    $(".menu-tendina .menu-item:not(.sub-menu .menu-item)").mouseenter(
      function() {
        $(".sub-menu").removeClass("sub-menu--active");
        $(this)
          .find(".sub-menu")
          .addClass("sub-menu--active");
      }
    );
  }

  $(document).ready(function() {
    menuDesktop();
  });
})(jQuery);

// $(document).on("click", 'a[href^="#"]', function(event) {
//   event.preventDefault();

//   $(".menu-tendina").removeClass("menu-tendina--active");
//   $(".backplate").removeClass("backplate--open");

//   $("html, body").animate(
//     {
//       scrollTop: $($.attr(this, "href")).offset().top - 120,
//     },
//     500
//   );
// });

// Menu mobile
jQuery(document).ready(function($) {
  const asideClass = "header--v4-mobile__aside";
  const subItemClass = "header--v4-mobile__subitem";

  $(`.${subItemClass}`).on("transitionend", function(e) {
    if (
      e.originalEvent.propertyName === "transform" &&
      $(this).hasClass(`${subItemClass}--move`)
    ) {
      $(`.${subItemClass}`).removeClass(`${subItemClass}--move`);
    }

    if (
      e.originalEvent.propertyName === "transform" &&
      $(this).hasClass(`${subItemClass}--close`)
    ) {
      // Close all tabs
      $(`.${subItemClass}`).addClass(`${subItemClass}--move`);
      $(`.${subItemClass}`).removeClass(`${subItemClass}--open`);
      $(`.${subItemClass}`).removeClass(`${subItemClass}--close`);
    }
  });

  $(".header-mobile__trigger").on("click", function() {
    if (window.innerWidth > 768) return;
    // $(".hamburger.hamburger--slider").toggleClass("is-active");
    $(`.${asideClass}`).toggleClass(`${asideClass}--open`);
    $(document.body).addClass("no-scroll");

    if (!$(`.${asideClass}`).hasClass(`${asideClass}--open`)) {
      $(`.${subItemClass}--open`).addClass(`${subItemClass}--close`);
      $(`.${asideClass}`).removeClass(`${asideClass}--move`);
    }
  });

  $(".header--v4-mobile__aside .header__close").on("click", function() {
    // $(".hamburger.hamburger--slider").removeClass("is-active");
    $(`.${asideClass}`).removeClass(`${asideClass}--open`);
    $(document.body).removeClass("no-scroll");

    if (!$(`.${asideClass}`).hasClass(`${asideClass}--open`)) {
      $(`.${subItemClass}--open`).addClass(`${subItemClass}--close`);
      $(`.${asideClass}`).removeClass(`${asideClass}--move`);
    }
  });

  $(".header--v4-mobile__link").on("click", function(e) {
    e.preventDefault();

    const cat = $(this).data("cat");

    $(`.${asideClass}`).addClass(`${asideClass}--move`);
    $(`.${subItemClass}[data-cat="${cat}"]`).addClass(`${subItemClass}--open`);
  });

  $(".header--v4-mobile__link--reverse").on("click", function(e) {
    e.preventDefault();
    $(this)
      .parents(`.${subItemClass}`)
      .removeClass(`${subItemClass}--open`);
    $(`.${asideClass}`).removeClass(`${asideClass}--move`);
  });

  $(".header--v4-mobile__subitem  .menu-item-has-children").on(
    "click",
    function(e) {
      const target = e.target;
      if (target.nodeName.toLowerCase() == "a") {
        if ($(target).parent(".menu-item-has-children").length <= 0) return;
      }

      e.preventDefault();

      const subMenu = $(this).children(".sub-menu");
      const back = $(e.target).hasClass("go-back")
        ? $(e.target)
        : $(e.target).parents(".go-back");

      if (back.length > 0) {
        return subMenu.removeClass("sub-menu--open");
      }

      if (subMenu.find(".go-back").length <= 0) {
        const text = $(this)
          .find("> a")
          .text();
        // subMenu.attr("title", `<span class="mr-sm">${svg}</span> ${text}`);

        const html = `
        <li class="go-back">
        <div class="header--v4-mobile__subitem-header">
          <div class="space-sm"></div>
          <span class="back flex flex-wrap items-center cursor-pointer">
            <span class="mr-sm"><svg class="zds-icon RC794g _98USAM DlJ4rT H3jvU7" height="1em" width="1em" focusable="false" fill="currentColor" viewBox="0 0 24 24" aria-hidden="false" aria-labelledby="arrow-left-8sw5j" role="img">
          <title id="arrow-left-8sw5j">arrow-left</title>
          <path d="M22.8 11.25H1.95l7.72-7.72A.75.75 0 008.6 2.47L.66 10.41c-.88.88-.88 2.3 0 3.18l7.94 7.94a.75.75 0 001.06 0c.3-.3.3-.77 0-1.06l-7.72-7.72H22.8a.75.75 0 000-1.5z"></path>
          </svg></span>
                <span class="title-m uppercase text-black">${text}</span>
            </span>
        </div>

        <div class="space-sm"></div>
        <div class="h-px bg-ui-4"></div>
        <div class="space-sm"></div>
        </li>
        `;

        subMenu.prepend(html);
      }

      // const parent = $(this).parents(`.${subItemClass}`);
      // parent.addClass(`${subItemClass}--move`);

      subMenu.addClass("sub-menu--open");
    }
  );
});
